import { gql } from '@apollo/client';

import { subscriptionPartial } from '../partials';
import { cartPartial } from '../partials/cart/Cart';

export const updateItemQuantitiesMutation = gql`
  mutation updateItemQuantities($key: ID!, $quantity: Int!) {
    updateItemQuantities(input: {items: {key: $key, quantity: $quantity}}) {
      clientMutationId
      ${cartPartial(subscriptionPartial)}
    }
  }
`;
